module.exports = __webpack_public_path__ + "static/img/img_cabinet.290fe551.png";